/*
 * @Author: KellyYang
 * @Date: 2022-06-28 10:09:17
 * @LastEditors: KellyYang
 * @Description: 关于我们
 */
import React, { Fragment } from "react";
import CompanyIntroduction from './components/CompanyIntroduction';
import EnterpriseDynamic from './components/EnterpriseDynamic';
import ContactUs from './components/ContactUs';
import { Tabs } from "antd";
import './index.less';

const { TabPane } = Tabs;
const TabPaneList = [
  {
    name: '公司介绍',
    value: CompanyIntroduction
  },
  {
    name: '企业动态',
    value: EnterpriseDynamic
  },
  {
    name: '联系我们',
    value: ContactUs
  }
]

const About = () => {
  return (
    <Fragment>
      <div className="about-page">
        <section>
          <div className="about-page-header">
            <div className="header-box">
              <div className="banner-title">
                <span>锦誉征信，您身边的信用管家</span>
              </div>
              {/* <div className="banner-subtitle">助力普惠金融的合规健康发展</div> */}
            </div>
          </div>
        </section>
        <section className="about-page-tabs-container">
          <Tabs className="about-page-tabs" defaultActiveKey="0" centered tabBarGutter={200}>
            {
              TabPaneList.map((item, index) => {
                return (
                  <TabPane tab={item.name} key={index}>
                    <item.value />
                  </TabPane>
                );
              })
            }
          </Tabs>
        </section>
        <section className="about-page-mobile-tabs-container">
          <Tabs className="about-page-tabs" defaultActiveKey="0" centered>
            {
              TabPaneList.map((item, index) => {
                return (
                  <TabPane tab={item.name} key={index}>
                    <item.value />
                  </TabPane>
                );
              })
            }
          </Tabs>
        </section>
      </div>
    </Fragment>
  )
}

export default About;
